<div class="view-container">
  <mat-card class="batch-list-container">
    <div class="batch-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>inventory</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Batches</h1>
      </div>

      <form class="batch-list__filters" [formGroup]="filterBatchesForm">
        <mat-form-field appearance="outline" class="batch-list__filter batch-list__filter--search" subscriptSizing="dynamic">
          <input matInput formControlName="batchNumber" placeholder="Search batch number" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" class="batch-list__filter batch-list__filter--status" subscriptSizing="dynamic">
          <mat-label>Status</mat-label>
          <mat-select formControlName="batchStatus">
            @for (status of batchStatuses; track status) {
              <mat-option [value]="status">
                {{ status.status }}
              </mat-option>
            }
          </mat-select>
          @if (selectedBatchStatus) {
            <button
              (click)="resetStatus()"
              mat-icon-button
              matSuffix
              type="button"
              [attr.aria-label]="'Clear status filter'"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="batch-list__filter batch-list__filter--medicine" subscriptSizing="dynamic">
          <input
            required
            [disabled]="isLoading"
            data-testid="add-medicine-name"
            type="text"
            placeholder="Search medicine"
            aria-label="Search for medicine"
            matInput
            formControlName="medicineName"
            [matAutocomplete]="auto"
          />
          <mat-autocomplete
            data-testid="medicine-autocompletion-list"
            (optionSelected)="medicineSelected($event)"
            autoActiveFirstOption
            #auto="matAutocomplete"
          >
            @for (med of medicine; track med) {
              <mat-option [value]="med">
                {{ med.name }}
              </mat-option>
            }
          </mat-autocomplete>
          <mat-icon matPrefix>search</mat-icon>
          @if (selectedMedicine) {
            <button
              (click)="resetMedicine()"
              mat-icon-button
              matSuffix
              type="button"
              [attr.aria-label]="'Clear medicine filter'"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </form>
    </div>

    <mat-paginator
      class="batch-list__paginator"
      [pageSizeOptions]="[10, 15, 20]"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [length]="totalNumberOfBatches"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of batches"
    >
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table mat-table [dataSource]="batchesDataSource" class="mbp-data-table batch-list">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="id-col">#</th>
          <td mat-cell *matCellDef="let batch" class="id-col">{{ batch.id }}</td>
        </ng-container>

        <ng-container matColumnDef="batch_number">
          <th mat-header-cell *matHeaderCellDef class="name-col">Batch number</th>
          <td mat-cell *matCellDef="let batch" class="name-col">{{ batch.batch_number }}</td>
        </ng-container>

        <ng-container matColumnDef="medicine">
          <th mat-header-cell *matHeaderCellDef>Medicine</th>
          <td mat-cell *matCellDef="let batch">{{ batch.medicine_dosage_type.medicine.name }}</td>
        </ng-container>

        <ng-container matColumnDef="quantity_produced">
          <th mat-header-cell *matHeaderCellDef>Quantity produced</th>
          <td mat-cell *matCellDef="let batch">{{ getQuantityProduced(batch) }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let batch">
            @if (batch.status) {
              <span class="badge {{ getBadgeBackground(batch.status) }}">{{ batch.status.status }}</span>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let batch">{{ getCreationTime(batch) }}</td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef>Updated</th>
          <td mat-cell *matCellDef="let batch">{{ formatTime(batch.updated_at) }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row (click)="openBatch(row.id)" *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card>
</div>
